import getCurrentGameSelected from './currentGameSelected';
import { getSDKConfig } from './getSDKConfig';

interface CurrentGame {
  currentGameId: string;
}

const eventEmitters = (
  eventType: string,
  feature = 'SwipeGame',
  eventData?: Record<string, unknown>,
): void => {
  const sdkConfig = getSDKConfig();
  const currentGame = getCurrentGameSelected() as CurrentGame;

  if (!sdkConfig || !currentGame) {
    console.error('SDK config or current game data is missing.');
    return;
  }

  const { onEvent, swipeGames } = sdkConfig;
  if (!onEvent) {
    return;
  }

  const { currentGameId } = currentGame;
  if (feature === 'MiniGame') {
    onEvent(eventType, eventData);
    return;
  }

  if (feature === 'Simulate') {
    onEvent(eventType, eventData);
    return;
  }

  onEvent(eventType, {
    gameId: currentGameId,
    iconPosition: swipeGames?.iconPosition,
    iconBgColor: swipeGames?.styles.iconBgColor,
    iconTop: swipeGames?.styles.iconTop,
    eventType: eventType,
  });
};

export default eventEmitters;
